import ProjectEntityHeader from '../shared/ProjectEntityHeader';
import ViewProjectPageMenu from '../Show/ViewProjectPageMenu';
import { useProjectId, useProjectService } from 'domain/shared/project';
import { Show } from 'framework/show';
import { ShowPageLayout } from 'framework/ui/layout';
import ProjectsWbsDashboardBreadcrumbs from './ProjectsWBSDashboardBreadcrumbs';
import { DataGridLayout, List, RelationListLayout } from 'framework/list';
import useProjectsWBSDashboardService from './useProjectsWBSDashboardService';
import { TextField } from 'framework/ui/field';
import UploadWbsButton from './buttons/UploadWBSButton';

const ProjectsWBSDashboardList = () => {
  const projectId = useProjectId();
  const { getById } = useProjectService();
  const { getWBSDashboardList } = useProjectsWBSDashboardService();

  return (
    <Show getDataMethod={() => getById(projectId)}>
      <ShowPageLayout
        entityHeader={<ProjectEntityHeader />}
        menu={<ViewProjectPageMenu />}
        breadcrumbs={<ProjectsWbsDashboardBreadcrumbs />}
      >
        <List getDataMethod={getWBSDashboardList}>
          <RelationListLayout header="WBS Dashboard" actions={[<UploadWbsButton />]}>
            <DataGridLayout>
              <TextField label="ID" source="id" width={80} />
              <TextField label="Estimation" source="estimation" width={15} />
              <TextField label="Actual Spent Time" source="actualSpentTime" width={15} />
            </DataGridLayout>
          </RelationListLayout>
        </List>
      </ShowPageLayout>
    </Show>
  );
};

export default ProjectsWBSDashboardList;
